import React from 'react';
import { Switch, Redirect } from 'react-router-dom';

import { RouteWithLayout } from './components';
import { AuthRouteWithLayout } from './components';
import { Main as MainLayout, Minimal as MinimalLayout } from './layouts';

import {
  Dashboard as DashboardView,
  Typography as TypographyView,

  Account as AccountView,
  // Settings as SettingsView,
  // SignUp as SignUpView,
  SignIn as SignInView,
  NotFound as NotFoundView,


  Devices as DeviceListView,
  DeviceAdd as DeviceAddView,
  DeviceUpdate as DeviceUpdateView,

  DeviceErrorUpdate as DeviceErrorUpdateView,

  Rooms as RoomListView,
  RoomAdd as RoomsAddView,
  RoomUpdate as RoomsUpdateView,

  Notices as NoticeView,
  NoticeAdd as NoticeAddView,
  NoticeUpdate as NoticeUpdateView,

  SensorHeatMap as SensorHeatMapView,
  HealthDataByDate as HealthDataByDateView,
  HealthDataByRoom as HealthDataByRoomView,
  AiReport as AiReportView,
  FirstAidUpdate as FirstAidUpdateView,

  Patients as PatientsView,
  PatientUpdate as PatientUpdateView,
  PatientAdd as PatientAddView,

  Caregivers as CaregiversView,
  CaregiverUpdate as CaregiverUpdateView,
  CaregiverAdd as CaregiverAddView,


  Settings as SettingsView,

  Auth as AuthListView,
  AuthUpdate as AuthUpdateView,
  AuthAdd as AuthAddView,

  EmergencyHistory as EmergencyHistoryView,
  WakeupHistory as WakeupHistoryView,

} from './views';


import thunkMiddleware from 'redux-thunk'
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import reducer from './reducers'
import { tempSetUser, updateFirebaseRoot } from 'actions/user';
import { createHashHistory } from 'history';
import { CONFIG_SETTINGS } from 'config.js';
import { loadSettings } from "common/login";


export const history = createHashHistory()


const middleware = applyMiddleware(thunkMiddleware)
const store = createStore(
  reducer,
  composeWithDevTools(middleware)
);


const loadLocalSettings = async() => {

  let val = localStorage.getItem(CONFIG_SETTINGS.FIREBASE_ROOT);

  if(!val){
    await loadSettings();
    val = localStorage.getItem(CONFIG_SETTINGS.FIREBASE_ROOT);
  }

  store.dispatch(updateFirebaseRoot(val));
}


const loadUser = () => {
  const userjson = localStorage.getItem(CONFIG_SETTINGS.USER_INFO);

  if(!userjson) return;

  let user = JSON.parse(userjson);
  store.dispatch(tempSetUser(user));
}


const Routes = (props) => {

  const {className, user, ...rest } = props;


  loadLocalSettings();
  loadUser();


  return (

    <Provider store={store}>

    <Switch>
      <Redirect
        exact
        from="/"
        to="/dashboard"
      />

      <RouteWithLayout
        component={DashboardView}
        exact
        layout={MainLayout}
        path="/dashboard"
      />


      <RouteWithLayout
        component={FirstAidUpdateView}
        exact
        layout={MainLayout}
        path="/firstaid/update/:eventId"
      />


      <RouteWithLayout
          component={EmergencyHistoryView}
          exact
          layout={MainLayout}
          path="/emergencyHistory"
        />

      <RouteWithLayout
          component={WakeupHistoryView}
          exact
          layout={MainLayout}
          path="/wakeupHistory"
        />


      <RouteWithLayout
          component={SensorHeatMapView}
          exact
          layout={MainLayout}
          path="/sensorHeatmap"
        />

      <RouteWithLayout
          component={HealthDataByDateView}
          exact
          layout={MainLayout}
          path="/healthdataByDate"
        />


      <RouteWithLayout
          component={HealthDataByRoomView}
          exact
          layout={MainLayout}
          path="/healthdataByRoom"
        />

      <RouteWithLayout
          component={AiReportView}
          exact
          layout={MainLayout}
          path="/aiReport"
        />


      <RouteWithLayout component={DeviceListView} exact layout={MainLayout} path="/devices" />
      <RouteWithLayout component={DeviceAddView} exact layout={MainLayout} path="/devices/add" />
      <RouteWithLayout component={DeviceUpdateView} exact layout={MainLayout} path="/devices/update/:deviceId" />

      <RouteWithLayout component={AuthListView} exact layout={MainLayout} path="/auth" />
      <RouteWithLayout component={AuthAddView} exact layout={MainLayout} path="/auth/add" />
      <RouteWithLayout component={AuthUpdateView} exact layout={MainLayout} path="/auth/update/:auth_id" />

      <RouteWithLayout
        component={DeviceErrorUpdateView}
        exact
        layout={MainLayout}
        path="/deviceError/update/:rowId"
      />


      <RouteWithLayout
        component={RoomListView}
        exact
        layout={MainLayout}
        path="/rooms"
      />


      <RouteWithLayout
        component={RoomsAddView}
        exact
        layout={MainLayout}
        path="/rooms/add"
      />

      <RouteWithLayout
        component={RoomsUpdateView}
        exact
        layout={MainLayout}
        path="/rooms/update/:roomId"
      />


      <RouteWithLayout
        component={PatientsView}
        exact
        layout={MainLayout}
        path="/patients"
      />

      <RouteWithLayout
        component={PatientAddView}
        exact
        layout={MainLayout}
        path="/patients/add"
      />


      <RouteWithLayout
        component={PatientUpdateView}
        exact
        layout={MainLayout}
        path="/patients/update/:patientId"
      />


      <RouteWithLayout
        component={CaregiversView}
        exact
        layout={MainLayout}
        path="/caregivers"
      />

      <RouteWithLayout
        component={CaregiverAddView}
        exact
        layout={MainLayout}
        path="/caregivers/add"
      />


      <RouteWithLayout
        component={CaregiverUpdateView}
        exact
        layout={MainLayout}
        path="/caregivers/update/:caregiverId"
      />


      <RouteWithLayout
        component={NoticeView}
        exact
        layout={MainLayout}
        path="/notice"
      />

      <RouteWithLayout
        component={NoticeAddView}
        exact
        layout={MainLayout}
        path="/notices/add"
      />

      <RouteWithLayout
        component={NoticeUpdateView}
        exact
        layout={MainLayout}
        path="/notices/update/:notice_id"
      />

      <RouteWithLayout
        component={AccountView}
        exact
        layout={MainLayout}
        path="/account"
      />

      <RouteWithLayout
        component={TypographyView}
        exact
        layout={MainLayout}
        path="/typography"
      />

      <RouteWithLayout
        component={SettingsView}
        exact
        layout={MainLayout}
        path="/settings"
      />

      {/* <RouteWithLayout
        component={SignUpView}
        exact
        layout={MinimalLayout}
        path="/sign-up"
      /> */}

      <RouteWithLayout
        exact
        component={SignInView}
        layout={MinimalLayout}
        path="/sign-in"
      />

      <RouteWithLayout
        component={NotFoundView}
        exact
        layout={MinimalLayout}
        path="/not-found"
      />
      <Redirect to="/not-found" />
    </Switch>
    </Provider>
  );
};

export default Routes;
